import React, {useMemo} from 'react';
import {Button, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface Props {
  plan: '1_month' | '12_month' | '24_month';
  currency?: string;
  active?: boolean;
  blur?: boolean;
  onClick?: () => void;
}

const MembershipTierV2: React.FC<Props> = ({
  plan,
  currency,
  active,
  blur,
  onClick,
}) => {
  const {t} = useTranslation();

  const selectPlanText = useMemo(() => {
    if (plan === '1_month') {
      return t('membership.selectMonthly');
    } else if (plan === '12_month') {
      return t('membership.select12Month');
    } else if (plan === '24_month') {
      return t('membership.select24Month');
    } else {
      return t('membership.selectPlan');
    }
  }, [plan, t]);

  const imagePath = useMemo(() => {
    if (currency === 'CAD') {
      return `/${plan}_cad.png`;
    }
    return `/${plan}.png`;
  }, [plan, currency]);

  return (
    <Button
      sx={{
        border: active ? '2px solid #fff' : '2px solid transparent',
        width: '100%',
        p: 4,
        borderRadius: '16% / 9%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& img': {
          opacity: blur ? 0.2 : 1,
          transition: 'opacity 0.2s ease',
        },
        '&:hover img': {
          opacity: 1,
        },
      }}
      onClick={onClick}>
      {active ? (
        <Typography
          variant="h5"
          sx={{
            position: 'absolute',
            top: 5,
            left: 0,
            right: 0,
            textAlign: 'center',
            color: 'info.main',
          }}>
          {t('general.active')}
        </Typography>
      ) : (
        <Typography
          variant="h5"
          sx={{
            position: 'absolute',
            top: 5,
            left: 0,
            right: 0,
            textAlign: 'center',
            color: 'primary.main',
          }}>
          {selectPlanText}
        </Typography>
      )}
      <img src={imagePath} style={{width: '100%', borderRadius: '12% / 6%'}} />
    </Button>
  );
};

export default MembershipTierV2;
